// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"b4a35444","257":"56d2da35","353":"2cf5567c","379":"7a7d1689","416":"2195efe9","488":"29b71886","718":"32d089b9"}[chunkId] + ".chunk.js";
};